/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { CSVLink } from 'react-csv'

const containerCss = (loading) => css`
  a {
    text-decoration: none;
  }

  border-left: 1px solid #bcc6d0;
  margin-left: 10px;
  padding-left: 12px;

  ${loading &&
  css`
    margin-top: 3px;
  `}

  .export {
    margin-top: -18px;
  }
`

const labelCss = css`
  color: #3f8cff;
  font-size: 17px;
  margin-top: 2px;

  :hover {
    text-decoration: underline;
  }
`

const disableCss = css`
  color: #3f8cff;
  opacity: 0.5;
  font-size: 17px;
  cursor: not-allowed;
`

const ExportToCSV = ({
  surveyName,
  structure = {},
  response = [],
  surveysLoading,
}) => {
  const headers = structure.map((el, index) => {
    let label = el.question

    if (el.type === 'SCORE') {
      label = `${el.question} (${el.score?.range?.min}-${el.score?.range?.max})`
    }

    return {
      label,
      key: `answer-${index}`,
    }
  })

  const data = response.map((el) => {
    const resp = {}
    try {
      Object.keys(el.response).forEach((e, i) => {
        const currResp = el.response[e]
        const currType = structure[i]?.type

        if (currType === 'TEXT_ANSWER') {
          resp[`answer-${i}`] = currResp
        }
        if (currType === 'MULTI_CHOICE') {
          resp[`answer-${i}`] = currResp
            ?.map((el) => structure[i].answers[el])
            ?.join('\n')
        }
        if (currType === 'SINGLE_CHOICE') {
          resp[`answer-${i}`] = structure[i]?.answers[currResp] || ''
        }
        if (currType === 'SCORE') {
          resp[`answer-${i}`] = currResp
        }
      })
    } catch (err) {
      console.error(err)
    }

    return resp
  })

  return (
    <div css={containerCss(surveysLoading)}>
      {surveysLoading || !response.length ? (
        <span css={disableCss}>Export to CSV</span>
      ) : (
        <CSVLink filename={`${surveyName}.csv`} headers={headers} data={data}>
          <span css={labelCss}>Export to CSV</span>
        </CSVLink>
      )}
    </div>
  )
}

export default ExportToCSV
